import * as React from 'react';
import $ from 'jquery';

export const Cameras = (props) => {
    const images = props.snapshots;
    const c1Div = React.useRef();
    const c2Div = React.useRef();
    const c3Div = React.useRef();
    const c4Div = React.useRef();
    const c5Div = React.useRef();
    const c6Div = React.useRef();
    const c7Div = React.useRef();
    const c8Div = React.useRef();
    let online = [true, true, true, true, , true, true];

    for (var i = 0; i < images.length; i++) {
        if (images[i].startsWith("Offline")) {
            images[i] = images[i].replace("Offline", "");
            online[i] = false;
        }
        let cd = c1Div.current;
        switch (i) {
            case 1: cd = c2Div.current; break;
            case 2: cd = c3Div.current; break;
            case 3: cd = c4Div.current; break;
            case 4: cd = c5Div.current; break;
            case 5: cd = c6Div.current; break;
            case 6: cd = c7Div.current; break;
            case 7: cd = c8Div.current; break;
        }
        if (cd !== undefined && cd !== null && cd.classList !== undefined) {
            if (online[i]) {
                cd.classList.remove("DeviceOffline");
            }
            else {
                cd.classList.add("DeviceOffline");
            }
        }
    }

    return (
        <div id="CameraPanel">
            {images.length > 0 && <div ref={c1Div}><img id="C1" src={images[0]} className={"cameraSnapshot"} /></div>}
            {images.length > 1 && <div ref={c2Div}><img id="C2" src={images[1]} className={"cameraSnapshot"} /></div>}
            {images.length > 2 && <div ref={c3Div}><img id="C3" src={images[2]} className={"cameraSnapshot"} /></div>}
            {images.length > 3 && <div ref={c4Div}><img id="C4" src={images[3]} className={"cameraSnapshot"} /></div>}
            {images.length > 4 && <div ref={c5Div}><img id="C5" src={images[0]} className={"cameraSnapshot"} /></div>}
            {images.length > 5 && <div ref={c6Div}><img id="C6" src={images[1]} className={"cameraSnapshot"} /></div>}
            {images.length > 6 && <div ref={c7Div}><img id="C7" src={images[2]} className={"cameraSnapshot"} /></div>}
            {images.length > 7 && <div ref={c8Div}><img id="C8" src={images[3]} className={"cameraSnapshot"} /></div>}
        </div>
    );
}